import { CodedProperty } from "../types/CodedProperty";

interface CodedEntity {
    id: string | number;
    name: string;
    code: string;
}

export const mapToCodedProperty = (value: CodedEntity): CodedProperty => {
    if (isCodedEntity(value)) {
        return {
            id: String(value.id),
            name: value.name,
            code: value.code
        };
    }

    throw new Error("Value is missing name or code.");
};

const isCodedEntity = (value: unknown): value is CodedEntity => {
    return (
        typeof value === "object" &&
        value !== null &&
        Object.keys(value).includes("id") &&
        Object.keys(value).includes("name") &&
        Object.keys(value).includes("code")
    );
};
